export default __webpack_public_path__ + "static/media/Martijn_Mulders.4b26baea.jpg";